import type { ProgramTimelineContentObject } from 'models';
import { useMemo } from 'react';

const TEXT_PREVIEW_LENGTH = 60;

export const useBodyTitle = (post: ProgramTimelineContentObject) =>
  useMemo(() => {
    const title = (() => {
      switch (post.type) {
        case 'activity':
          return post.activity.name;
        case 'event':
          return post.event.name;
        case 'poll':
          return post.poll.title;
        case 'post':
          return post.post.title ?? post.post.textContent;
        case 'withings_order_post':
          return post.withings_order_post.title ?? post.withings_order_post.textContent;
      }
    })();

    return title && title.length > TEXT_PREVIEW_LENGTH
      ? `${title.slice(0, Math.max(0, TEXT_PREVIEW_LENGTH))}...`
      : title;
  }, [post]);
